import { render, staticRenderFns } from "./MortgageAlternativeCard.vue?vue&type=template&id=3baac82c&scoped=true"
import script from "./MortgageAlternativeCard.vue?vue&type=script&lang=js"
export * from "./MortgageAlternativeCard.vue?vue&type=script&lang=js"
import style0 from "./MortgageAlternativeCard.vue?vue&type=style&index=0&id=3baac82c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baac82c",
  null
  
)

export default component.exports